module.exports = __webpack_public_path__ + "img/voucher.f8832fb0.svg";